import * as React from 'react';
import { Redirect } from 'react-router-dom';

import NavBar from '../../../components/CustomNav/CustomNav.Component';
import withServices from '../../../HOCs/withServices';
import { Container } from '../Common/Common.styles';
import { StyledRow, PackagesWrapper, PackageItem } from './Packages.styles';

interface IProps {
    services?: any;
    history?: any;
}

interface IState {
    navigate: boolean;
    destination: string;
}

class Packages extends React.Component <IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            navigate: false,
            destination: ''
        }

        this.onLogout = this.onLogout.bind(this); 
        this.navigate = this.navigate.bind(this);
        this.checkout = this.checkout.bind(this);

    }

    public async componentDidMount() {
        // api calls, login checks, onboarding done check
    }

    public onLogout() {
        this.setState({navigate: true, destination: '/login'});
    }
    public navigate(destination) {
        const { history } = this.props;
        history.push(`/onboarding/${destination}`);
    }
    public checkout() {
        alert("This will link to checkout pages");
    }

    public render() {
        if(this.state.navigate) {
            return <Redirect to={this.state.destination} />
        }

        return(
            <Container>
                <NavBar logoutParent={this.onLogout} />
                <StyledRow>
                    <h1 className="package-heading">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet, dolores?</h1>
                    <PackagesWrapper>
                        <PackageItem>
                            <div className="package-name">
                                <h1 className="package-title">INDIVIDUAL</h1>
                                <p className="package-target">For Students and Teachers</p>
                            </div>
                            <div className="package-value">
                                <h1 className="price"><sup>&pound;</sup>29.99<span>/p/m</span></h1>
                            </div>
                            <div className="features-list">
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                            
                                <button className="green-button" onClick={this.checkout}>sign up</button>
                            </div>
                        </PackageItem>
                        <PackageItem className="recommended-package">
                            <div className="package-name selected-package">
                                <h1 className="package-title">Family</h1>
                                <p className="package-target">For Groups and Families</p>
                            </div>
                            <div className="package-value">
                                <h1 className="price"><sup>&pound;</sup>19.99<span>/p/m</span></h1>
                            </div>
                            <div className="features-list">
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                            
                                <button className="green-button" onClick={this.checkout}>sign up</button>
                            </div>
                        </PackageItem>
                        <PackageItem>
                            <div className="package-name">
                                <h1 className="package-title">INSTITUTION</h1>
                                <p className="package-target">For Schools and Colleges</p>
                            </div>
                            <div className="package-value">
                                <h1 className="price"><sup>&pound;</sup>Contact Us</h1>
                            </div>
                            <div className="features-list">
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                                <p className="feature-item">Lorem, ipsum dolor.</p>
                            
                                <button className="green-button" onClick={this.checkout}>contact us</button>
                            </div>
                        </PackageItem>
                    </PackagesWrapper>
                    <button className="red-button to-postpayment" onClick={this.navigate.bind(this, 'postpayment')}>SKIP TO POSTPAYMENT</button>
                </StyledRow>
            </Container>
        )
    }
}

export default withServices(Packages)


// WEBPACK FOOTER //
// ./src/pages/Onboard/Packages/Packages.Component.tsx